'use client';

import { ISalePageDetailV2ResponseProduct } from '@/api/types';
import { HorizontalScrollbar } from '@/components';
import { GachaTicketButton } from './GachaTicketButton';
import * as styles from './scrollGachaButtonGroupOnSaleItems.css';
import { getGachaCtaForProduct } from './selectGachaCta';

interface IScrollGachaButtonGroupOnSaleItemsProps {
  products: ISalePageDetailV2ResponseProduct[];
  onClick: (productId: number) => void;
}

export const ScrollGachaButtonGroupOnSaleItems = ({
  products,
  onClick,
}: IScrollGachaButtonGroupOnSaleItemsProps) => {
  return (
    <HorizontalScrollbar slideWidth={128} className={styles.scrollbar}>
      {products.map(product => (
        <GachaTicketButton
          key={product.id}
          {...getGachaCtaForProduct(product, onClick)}
        />
      ))}
    </HorizontalScrollbar>
  );
};
